import React from 'react';

const App = () => {
  return (
      <div className="bg-white p-6 rounded-lg shadow">
        <h2 className="text-xl font-semibold mb-4">Tailwind is working!</h2>
        <p className="text-gray-700">
          Painel pronto para adicionar seu conteúdo.
        </p>
      </div>
  );
};

export default App;
